import { Modal, MortarProvider } from '@policygenius/mortar';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { jss } from 'react-jss';
import { BrowserRouter } from 'react-router-dom';
import { polyfill as polyfillSmoothScroll } from 'smoothscroll-polyfill';

import AuthProvider from 'contexts/Auth';
import initPgFlags from 'util/optimizely/PgFlags';
import { initPGExperiments } from 'util/optimizelyHelpers';

import './styles/index.scss'; // eslint-disable-line import/no-unassigned-import

import LifeWeb from './app';

export { default as apolloClient } from 'graphql/apollo';

jss.setup({
  insertionPoint: 'jss-insertion-point',
});

const render = () => {
  const container = document.getElementById('app');
  const root = createRoot(container!);

  root.render(
    <MortarProvider>
      <BrowserRouter>
        <AuthProvider>
          <LifeWeb />
        </AuthProvider>
      </BrowserRouter>
    </MortarProvider>
  );
};

if (process.env.NODE_ENV !== 'production') {
  initPGExperiments();
  initPgFlags();
}

// https://reactcommunity.org/react-modal/accessibility/#app-element
Modal.setAppElement('#app');

polyfillSmoothScroll();
render();
